import React, { useEffect, useState } from "react";
import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";
import MultiSelectInput from "../../../components/MultiSelectInput";
import { BarsArrowUpIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Disclosure } from "@headlessui/react";
import { useSFGetOffice } from "../OfficeSettings/hooks/useSFGetOffice";
import { useGetCarriers } from "../Carrier/hooks/useGetCarriers";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import SelectInput from "../../../components/SelectInput";
import { useStates } from "../hooks/useStates";
import {
  searchDataProdCode,
  isFranchiseFilterState,
  fromRecentActivity,
  fromRecentActivityId,
  defaultProdSearchParams,
} from "./atoms/atoms";
const TableFilters = ({
  searchProducerCode,
  setFilterStatus,
  setFilteredproducerCodeData,
  setIsFilterMainTable,
}) => {
  const user = useRecoilValue(accountAtom);
  const [, setFromRecent] = useRecoilState(fromRecentActivity);
  const [, setFromRecentId] = useRecoilState(fromRecentActivityId);
  const setIsFranchiseFilter = useSetRecoilState(isFranchiseFilterState);
  const [searchInputsData, setSearchInputsData] =
    useRecoilState(searchDataProdCode);
  const { data: agenciesQuery, isLoading } = useSFGetOffice();
  const agencies =
    agenciesQuery &&
    agenciesQuery
      ?.filter((c) => c.officeCode !== null && c.officeCode !== "")
      .map((resData) => ({
        label:
          resData.officeName +
          "-" +
          resData.officeCode +
          "-" +
          (resData.storeNumber !== "" ? resData.storeNumber : "0"),
        value: resData.officeCode,
        state: resData.stateCode,
        officeName: resData.officeName + "-" + resData.officeCode,
      }));
  const { data: stateQuery } = useStates();
  const states =
    stateQuery &&
    stateQuery?.map((data) => {
      return { label: data.state, value: data.state };
    });
  const { data: carriersQuery } = useGetCarriers();
  const carriers =
    carriersQuery &&
    carriersQuery
      .filter((x) => x.isActive)
      .map((resData) => ({
        label: resData.carrierName,
        value: resData.masterCarrierId,
      }));

  const refreshProducerCode = () => {
    //setFilterStatus(false);
    setIsFilterMainTable(false);
    setSearchInputsData(defaultProdSearchParams);
    setFilteredproducerCodeData([]);
    setFromRecent(false);
    setFromRecentId(null);
  };

  const handleFieldChange = (value, fieldName, selectedFieldName) => {
    const selectedField = selectedFieldName;
    setSearchInputsData({
      ...searchInputsData,
      [fieldName]: value,
      [selectedField]: value,
    });
  };

  const franchiseORConfie = [
    { label: "Confie", value: 0 },
    { label: "Franchise", value: 1 },
  ];

  const handleFranchiseConfieSelect = (selected) => {
    //setSelectedFranchiseConfie(selected);
    setSearchInputsData({
      ...searchInputsData,
      selectedFranchiseConfie: selected ? selected : [],
    });
  };

  return (
    <div className="pr-3 space-y-2 pt-2">
      <div>
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full ">
        <div className="w-full max-w-md  mx-auto bg-white rounded-2xl">
          <Disclosure defaultOpen>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full mb-2 px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span>Producer Code Details</span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="w-full">
                    <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                      {user.isFranchise && user.isNonFranchise ? (
                        <div className="w-full">
                          <label className="block font-medium text-gray-700 mb-2">
                            Franchise/Confie
                          </label>
                          <div className="w-full">
                            <SelectInput
                              options={franchiseORConfie}
                              //value={selectedFranchiseConfie}
                              value={searchInputsData.selectedFranchiseConfie}
                              onChange={(options) => {
                                handleFranchiseConfieSelect(options);
                                setIsFranchiseFilter(true);
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          States
                        </label>
                        <div className="w-full">
                          <MultiSelectInput
                            // options={getUnique(carriers, "label")}
                            options={states?.filter(
                              (v, i, a) =>
                                a.findIndex(
                                  (t) =>
                                    t.label === v.label && t.value === v.value
                                ) === i
                            )}
                            value={searchInputsData.selectedState}
                            handleMultiSelect={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                State: e.map((x) => x.label),
                                selectedState: e,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Carriers
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <MultiSelectInput
                            // options={getUnique(carriers, "label")}
                            options={carriers?.filter(
                              (v, i, a) =>
                                a.findIndex(
                                  (t) =>
                                    t.label === v.label && t.value === v.value
                                ) === i
                            )}
                            className="sm:w-full md:w-full lg:w-full"
                            value={searchInputsData.selectedCarrier}
                            handleMultiSelect={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                CarrierName: e.map((x) => x.label),
                                selectedCarrier: e,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Offices
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <MultiSelectInput
                            isDisabled={isLoading}
                            place
                            options={agencies?.filter(
                              (v, i, a) =>
                                a.findIndex(
                                  (t) =>
                                    t.label === v.label && t.value === v.value
                                ) === i
                            )}
                            className="sm:w-full md:w-full lg:w-full"
                            value={searchInputsData.selectedOffice}
                            handleMultiSelect={(e) =>
                              setSearchInputsData({
                                ...searchInputsData,
                                OfficeName: e.map((x) => x.label),
                                OfficeCode: e.map((x) => x.value),
                                selectedOffice: e,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"Producer Code"}
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <TextInput
                            // defaultValue={producerCode}
                            name="ProducerCode"
                            value={searchInputsData.selectedProducerCode}
                            onChange={(e) => {
                              handleFieldChange(
                                e.target.value,
                                "ProducerCode",
                                "selectedProducerCode"
                              );
                            }}
                            className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"M&A Producer Code"}
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <TextInput
                            // defaultValue={producerCode}
                            name="MAProducerCode"
                            value={searchInputsData.selectedMaProducerCode}
                            onChange={(e) => {
                              handleFieldChange(
                                e.target.value,
                                "MAProducerCode",
                                "selectedMaProducerCode"
                              );
                            }}
                            className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"Acquisition Name"}
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <TextInput
                            // defaultValue={producerCode}
                            name="acquisitionName"
                            value={searchInputsData.selectedAcquisitionName}
                            onChange={(e) => {
                              handleFieldChange(
                                e.target.value,
                                "AcquisitionName",
                                "selectedAcquisitionName"
                              );
                            }}
                            className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                          />
                        </div>
                      </div>
                      <div className="place-self-center">
                        <div className="flex flex-row gap-3 justify-center m-3">
                          <SearchButton
                            buttonValue="Search"
                            onClick={() => {
                              searchProducerCode();
                            }}
                          />
                          <RefreshButton
                            onClick={() => {
                              refreshProducerCode();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>{" "}
    </div>
  );
};

export default TableFilters;
